import * as React from 'react';
import { useStyles } from './styles';
import Box from '@mui/material/Box';

const VideoGamecast = () => {
  const classes = useStyles();

  return (
    <Box sx={classes.root}>
      <video
        playsInline
        autoPlay
        id="gamecastVideoTag"
        muted
        onContextMenu={(event) => {
          event.preventDefault();
          return false;
        }}
      ></video>
    </Box>
  );
};

export default VideoGamecast;
